import { useCallback } from 'react';
import { routes } from 'routes/routes';
import { Button, CheckLineIcon, Flex, Modal, Settings5LineIcon } from 'ui';
import { useReadAllNotifications } from '../queries';

const NotificationsNav = () => {
  const [modal, contextHolder] = Modal.useModal();
  const { mutate: readAllNotifications } = useReadAllNotifications();

  const handleMarkAllAsRead = useCallback(() => {
    modal.confirm({
      content: 'Are you sure you want to mark all notifications as read?',
      okText: 'Mark all as read',
      onOk() {
        readAllNotifications({});
      },
      title: 'Mark all as read',
    });
  }, [modal, readAllNotifications]);

  return (
    <Flex gap="ms">
      {contextHolder}
      <Button icon={<CheckLineIcon />} onClick={handleMarkAllAsRead}>
        Mark all as read
      </Button>
      <Button icon={<Settings5LineIcon />} navigate={{ to: routes.user.settings }}>
        Notifications Settings
      </Button>
    </Flex>
  );
};

export default NotificationsNav;
